// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2bzTi","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__TCkzW"};